angular.module('ihestiaCommonDirectives')
  .directive('saveFormRef', ['$parse', function($parse){
    return {
      link: function($scope, iElm, iAttrs) {
        var setter = $parse(iAttrs.saveFormRef).assign;
        setter($scope, $scope[iAttrs.ngForm ? iAttrs.ngForm : iAttrs.name]);
      }
    };
  }]);